import { createReducer } from '@common/redux-utils';
import {
  PropertyManagementActionType,
  GetPropertyManagementDetailsStartAction,
  GetPropertyManagementOfficeDetailsSuccessAction,
  GetPropertyManagementOfficeDetailsFailureAction,
  SavePropertyManagementOfficeStartAction,
  PropertyManagementOfficeSearchInitAction,
  PropertyManagementOfficeSearchSuccessAction,
  PropertyManagementOfficeSearchFailureAction,
  GetPropertyManagersStartAction,
  GetPropertyManagersSuccessAction,
  GetPropertyManagersFailureAction,
  ClearPropertyManagementOfficeAction
} from './property-management.actions';
import { PropertyManagementOfficeViewModel } from '@models/PropertyManagementOffice';
import { PropertyManagerSearchViewModel } from '@models/PropertyManager';

export interface PropertyManagementState {
  readonly propertyManagementOfficeVM: PropertyManagementOfficeViewModel | null; // for loading the office details into
  readonly officeSearchLoading: boolean;
  readonly officeSearchPageNumber: number;
  readonly officeSearchPageSize: number;
  readonly officeSearchPageCount: number;
  readonly officesForSearch: PropertyManagementOfficeViewModel[];
  readonly officeSearchQuery: string | null;
  readonly officeSearchOrderBy: string;
  readonly officeSearchMessage: string;
  readonly propertyManagers: PropertyManagerSearchViewModel[];
  readonly saving?: boolean;
}

export const initialPropertyManagementState: PropertyManagementState = {
  propertyManagementOfficeVM: null,
  officeSearchLoading: false,
  officeSearchPageNumber: 1,
  officeSearchPageCount: 1,
  officeSearchPageSize: 10,
  officesForSearch: [],
  officeSearchQuery: null,
  officeSearchMessage: '',
  officeSearchOrderBy: '',
  propertyManagers: []
};

function handleGetPropertyManagementOfficeDetailsStart(
  state: PropertyManagementState,
  action: GetPropertyManagementDetailsStartAction
) {
  return {
    ...state
  };
}

function handleGetPropertyManagementOfficeDetailsFailure(
  state: PropertyManagementState,
  action: GetPropertyManagementOfficeDetailsFailureAction
) {
  return {
    ...state
  };
}

function handleGetPropertyManagementOfficeDetailsSuccess(
  state: PropertyManagementState,
  action: GetPropertyManagementOfficeDetailsSuccessAction
) {
  return {
    ...state,
    propertyManagementOfficeVM: action.propertyManagementVM
  };
}

function handleSavePropertyManagementOfficeStart(
  state: PropertyManagementState,
  action: SavePropertyManagementOfficeStartAction
) {
  return {
    ...state,
    saving: true
  };
}

function handleSavePropertyManagementOfficeSuccess(
  state: PropertyManagementState,
  action: SavePropertyManagementOfficeStartAction
) {
  return {
    ...initialPropertyManagementState,
    saving: false
  };
}

function handleSavePropertyManagementOfficeFailure(
  state: PropertyManagementState,
  action: SavePropertyManagementOfficeStartAction
) {
  return {
    ...state,
    saving: false
  };
}

function handleSearchPropertyManagementOfficeInit(
  state: PropertyManagementState,
  action: PropertyManagementOfficeSearchInitAction
): PropertyManagementState {
  return {
    ...state,
    officeSearchQuery: action.query,
    officeSearchLoading: true
  };
}

function handleSearchPropertyManagementOfficeSuccess(
  state: PropertyManagementState,
  action: PropertyManagementOfficeSearchSuccessAction
): PropertyManagementState {
  return {
    ...state,
    //  message: 'Search Success!',
    officeSearchLoading: false,
    //       officeSearchTotalResults: action.result.totalResults,
    officeSearchPageCount: Math.ceil(action.result.totalResults / action.result.pageSize),
    officeSearchPageNumber: action.pageNumber,
    officeSearchPageSize: action.pageSize,
    officeSearchOrderBy: action.orderBy,
    officesForSearch: action.result.results
  };
}

function handleSearchPropertyManagementOfficeFailure(
  state: PropertyManagementState,
  action: PropertyManagementOfficeSearchFailureAction
): PropertyManagementState {
  return {
    ...state,
    //  message: action.errorMessage,
    officeSearchLoading: false
  };
}

function handleGetPropertyManagersStart(state: PropertyManagementState, action: GetPropertyManagersStartAction) {
  return {
    ...state
  };
}

function handleGetPropertyManagersSuccess(state: PropertyManagementState, action: GetPropertyManagersSuccessAction) {
  return {
    ...state,
    propertyManagers: action.propertyManagers
  };
}

function handleGetPropertyManagersFailure(state: PropertyManagementState, action: GetPropertyManagersFailureAction) {
  return {
    ...state,
    message: action.message
  };
}

function handleClearPropertyManagementOffice(
  state: PropertyManagementState,
  action: ClearPropertyManagementOfficeAction
) {
  return {
    ...state,
    propertyManagementOfficeVM: null,
    propertyManagers: [],
    saving: false
  };
}

export const PropertyManagementReducer = createReducer<PropertyManagementState, PropertyManagementActionType>(
  initialPropertyManagementState,
  {
    [PropertyManagementActionType.GetPropertyManagementOfficeDetailsStart]: handleGetPropertyManagementOfficeDetailsStart,
    [PropertyManagementActionType.GetPropertyManagementOfficeDetailsFailure]: handleGetPropertyManagementOfficeDetailsFailure,
    [PropertyManagementActionType.GetPropertyManagementOfficeDetailsSuccess]: handleGetPropertyManagementOfficeDetailsSuccess,

    [PropertyManagementActionType.SavePropertyManagementOfficeStart]: handleSavePropertyManagementOfficeStart,
    [PropertyManagementActionType.SavePropertyManagementOfficeSuccess]: handleSavePropertyManagementOfficeSuccess,
    [PropertyManagementActionType.SavePropertyManagementOfficeFailure]: handleSavePropertyManagementOfficeFailure,

    [PropertyManagementActionType.SearchPropertyManagmentOfficeInit]: handleSearchPropertyManagementOfficeInit,
    [PropertyManagementActionType.SearchPropertyManagmentOfficeSuccess]: handleSearchPropertyManagementOfficeSuccess,
    [PropertyManagementActionType.SearchPropertyManagmentOfficeFailure]: handleSearchPropertyManagementOfficeFailure,

    [PropertyManagementActionType.GetPropertyManagersStart]: handleGetPropertyManagersStart,
    [PropertyManagementActionType.GetPropertyManagersSuccess]: handleGetPropertyManagersSuccess,
    [PropertyManagementActionType.GetPropertyManagersFailure]: handleGetPropertyManagersFailure,
    [PropertyManagementActionType.ClearPropertyManagementOffice]: handleClearPropertyManagementOffice
  }
);



// WEBPACK FOOTER //
// ./src/property-management/property-management.reducer.ts